// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"BrowseExt\"] {\r\n\tcolor: var(--primary-font-color);\r\n\tjustify-content: center;\r\n\tfont-size: 14px;\r\n\t-webkit-user-select: none;\r\n\t   -moz-user-select: none;\r\n\t    -ms-user-select: none;\r\n\t        user-select: none;\r\n\t\r\n}\r\n\t[name=\"BrowseExt\"] .browse-ext-container {\r\n\t\tflex-basis: 80%;\r\n\t}\r\n\t[name=\"BrowseExt\"] .dropdown-container {\r\n\t\tmargin: 20px 0px;\r\n\t}", ""]);
// Exports
module.exports = exports;
